import { NavLink } from 'react-router-dom';

import homeSvg from '@/assets/icons/nav/home.svg?raw';
import mapSvg from '@/assets/icons/nav/map.svg?raw';
import scoutSvg from '@/assets/icons/nav/scout.svg?raw';
import prepSvg from '@/assets/icons/nav/prep.svg?raw';
import moreSvg from '@/assets/icons/nav/more.svg?raw';

interface NavTab {
  to: string;
  label: string;
  iconSvg: string;
  /** Match any route that starts with this prefix (for sub-routes) */
  matchPrefix?: string;
}

const TABS: NavTab[] = [
  { to: '/', label: 'Home', iconSvg: homeSvg, matchPrefix: undefined },
  { to: '/map', label: 'Map', iconSvg: mapSvg, matchPrefix: '/map' },
  { to: '/scout', label: 'Scout', iconSvg: scoutSvg, matchPrefix: '/scout' },
  { to: '/prep', label: 'Prep', iconSvg: prepSvg, matchPrefix: '/prep' },
  { to: '/more', label: 'More', iconSvg: moreSvg, matchPrefix: '/more' },
];

export function BottomNav() {
  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-20 bg-bark-800 border-t border-bark-600 flex items-stretch"
      style={{
        height: 'calc(56px + env(safe-area-inset-bottom))',
        paddingBottom: 'env(safe-area-inset-bottom)',
      }}
      aria-label="Main navigation"
      data-testid="bottom-nav"
    >
      {TABS.map(({ to, label, iconSvg, matchPrefix }) => (
        <NavLink
          key={to}
          to={to}
          end={!matchPrefix}
          className={({ isActive }) =>
            [
              'flex-1 flex flex-col items-center justify-center gap-0.5 transition-all duration-100',
              isActive
                ? 'text-ember-500'
                : 'text-bark-200 hover:text-bark-100',
            ].join(' ')
          }
          aria-label={label}
          data-testid={`nav-${label.toLowerCase()}`}
        >
          {({ isActive }) => (
            <>
              {/* SAFETY: iconSvg is a static import from compiled SVG assets — stroke="currentColor" inherits tab color */}
              <span
                className="w-6 h-6 flex items-center justify-center"
                aria-hidden="true"
                data-active={isActive ? 'true' : 'false'}
                dangerouslySetInnerHTML={{ __html: iconSvg }}
              />
              <span className="text-[10px] font-medium tracking-wide leading-none">
                {label}
              </span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
}
